"use client";

import { useEffect, useState } from "react";

interface Toast {
  id: number;
  message: string;
  type?: "success" | "danger" | "info";
}

let listeners: Array<(t: Toast) => void> = [];
let counter = 0;

export function toast(message: string, type: Toast["type"] = "info") {
  const t: Toast = { id: ++counter, message, type };
  listeners.forEach((fn) => fn(t));
}

export default function Toaster() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  useEffect(() => {
    const fn = (t: Toast) => {
      setToasts((prev) => [...prev, t]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((x) => x.id !== t.id));
      }, 2800);
    };
    listeners.push(fn);
    return () => {
      listeners = listeners.filter((x) => x !== fn);
    };
  }, []);

  return (
    <div
      className="fixed left-1/2 bottom-24 -translate-x-1/2 z-[300] flex flex-col gap-2 items-center pointer-events-none"
      aria-live="polite"
      aria-atomic="true"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`px-5 py-3 rounded-full font-semibold text-[13.5px] text-white shadow-[0_16px_40px_rgba(15,28,46,0.35)] backdrop-blur fade-up ${
            t.type === "success"
              ? "bg-gradient-to-br from-[#0f7d3a] to-[#0fa28d]"
              : t.type === "danger"
                ? "bg-[#c43b3b]"
                : "bg-ss-text/95"
          }`}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
